import { PropType, defineComponent } from 'vue'

import { screenSizeDetection } from '@sunrise/shared'
import { Components } from '@sunrise/types'

import { DecoratedContactDetails } from '../../ts/mapper/decoratedEstateDetailMapper.interface'
import { DecoratedEstate } from '../../ts/mapper/decoratedItemEstate.interface'

import { ContactBtnPosition } from '../MsDetailContactBtnGroup/MsDetailContactBtnGroup.enum'
import MsDetailContactBtnGroup from '../MsDetailContactBtnGroup/MsDetailContactBtnGroup.vue'
import MsDetailModalCall from '../MsDetailModalCall/MsDetailModalCall.vue'
import MsLikeButton from '../MsLikeButton/MsLikeButton.vue'
import MsStickyContainer from '../MsStickyContainer/MsStickyContainer.vue'

export default defineComponent({
    name: 'MsDetailStickyBar',
    components: { MsLikeButton, MsDetailContactBtnGroup, MsDetailModalCall, MsStickyContainer },
    props: {
        estate: {
            type: Object as PropType<DecoratedEstate>,
            required: true,
        },
        exposeeId: {
            type: Number,
            required: true,
        },
        contact: {
            type: Object as PropType<DecoratedContactDetails>,
            required: true,
        },
        keyInfo: {
            type: Array as PropType<Components.CsDataSheet.DataSheetEntry[]>,
            default: () => [] as Components.CsDataSheet.DataSheetEntry[],
            required: true,
        },
        componentId: {
            type: String,
            required: true,
        },
    },
    setup() {
        const { isScreenL } = screenSizeDetection()
        const maxKeyInfosInStickyBar = 3

        const truncateKeyInfos = (keyInfos: Components.CsDataSheet.DataSheetEntry[]) =>
            keyInfos.slice(0, maxKeyInfosInStickyBar)

        return {
            isScreenL,
            truncateKeyInfos,
            ContactBtnPosition,
        }
    },
})
